/* ============================================
   Complaint Registration — complaint-registration.js
   Submits form data to Euronics Lead API
   ============================================ */

(function () {
  'use strict';

  function initComplaintRegistration() {
    var form      = document.getElementById('ComplaintRegistrationForm');
    if (!form || form.dataset.crInitialized === 'true') return;
    form.dataset.crInitialized = 'true';

    var submitBtn = document.getElementById('crSubmitBtn');
    var btnText   = document.getElementById('crBtnText');
    var btnLoader = document.getElementById('crBtnLoader');
    var apiError  = document.getElementById('crApiError');
    var successEl = document.getElementById('crSuccessMessage');

    var SHEET_URL = 'https://script.google.com/macros/s/AKfycbyyM2NcczWLY9o4AyupcoBVHYNYhbJjiVeycrs_gT5eswlsJ1U1tf-kCemgIVfVtfZ9_w/exec';

    /* ── UTM Params ───────────────────────────────── */
    function getUTM() {
      var p = new URLSearchParams(window.location.search);
      return {
        utm_source:   p.get('utm_source')   ? '- ' + p.get('utm_source')   : '- utm_source',
        utm_medium:   p.get('utm_medium')   ? '- ' + p.get('utm_medium')   : '- utm_medium',
        utm_campaign: p.get('utm_campaign') ? '- ' + p.get('utm_campaign') : '- utm_campaign',
        gclid:        p.get('gclid')        ? '- ' + p.get('gclid')        : '- gclid'
      };
    }

    /* ── UI Helpers ───────────────────────────────── */
    function setLoading(on) {
      submitBtn.disabled      = on;
      btnText.style.display   = on ? 'none'         : 'inline-flex';
      btnLoader.style.display = on ? 'inline-block' : 'none';
    }

    function clearErrors() {
      apiError.style.display = 'none';
      apiError.textContent   = '';
      form.querySelectorAll('.cr-field-error').forEach(function (el) {
        el.classList.remove('cr-field-error');
      });
    }

    function markError(id) {
      var el = document.getElementById(id);
      if (!el) return;
      // If it's the phone input, mark the wrapper
      if (id === 'cr-mobile') {
        var wrap = el.closest('.cr-phone-wrapper');
        if (wrap) wrap.classList.add('cr-field-error');
      } else {
        el.classList.add('cr-field-error');
      }
    }

    /* ── Validation ───────────────────────────────── */
    function validate(d) {
      var ok = true;
      if (!d.Company)        { markError('cr-company');        ok = false; }
      if (!d.Address)        { markError('cr-address');        ok = false; }
      if (!d.State)          { markError('cr-state');          ok = false; }
      if (!d.Pincode || !/^\d{4,10}$/.test(d.Pincode)) {
        markError('cr-pincode'); ok = false;
      }
      if (!d.ContactPerson)  { markError('cr-contact-person'); ok = false; }

      if (!d.Email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(d.Email)) {
        markError('cr-email'); ok = false;
      }
      if (!d.Mobile || !/^\d{10}$/.test(d.Mobile)) {
        markError('cr-mobile'); ok = false;
      }
      return ok;
    }

    /* ── Success UI ───────────────────────────────── */
    function showSuccess() {
      form.reset();
      var grid      = form.querySelector('.cr-form-grid');
      var btnWrap   = form.querySelector('.cr-btn-wrapper');
      if (grid)    grid.style.display    = 'none';
      if (btnWrap) btnWrap.style.display = 'none';
      if (successEl) successEl.style.display = 'block';

      // Smooth scroll to the success message
      successEl.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }

    /* ── Numeric-only inputs for Pincode & Mobile ── */
    ['cr-pincode', 'cr-mobile'].forEach(function (id) {
      var el = document.getElementById(id);
      if (!el) return;
      el.addEventListener('input', function () {
        this.value = this.value.replace(/\D/g, '');
      });
    });

    /* ── Form Submit ──────────────────────────────── */
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      clearErrors();

      var data = {
        Company:       document.getElementById('cr-company').value.trim(),
        Email:         document.getElementById('cr-email').value.trim(),
        Address:       document.getElementById('cr-address').value.trim(),
        City:          document.getElementById('cr-city').value.trim(),
        State:         document.getElementById('cr-state').value.trim(),
        Pincode:       document.getElementById('cr-pincode').value.trim(),
        Mobile:        document.getElementById('cr-mobile').value.trim(),
        ContactPerson: document.getElementById('cr-contact-person').value.trim(),
        PurchaseChannel: document.getElementById('cr-purchase-channel').value.trim(),
        InvoiceNumber: document.getElementById('cr-invoice').value.trim(),
        Problem:       document.getElementById('cr-problem').value.trim()
      };

      if (!validate(data)) {
        apiError.textContent   = '❌ Please fill in all required fields correctly.';
        apiError.style.display = 'block';
        return;
      }

      var utm = getUTM();

      setLoading(true);

      // ── Send data to Google Sheet ──────────────
      fetch(SHEET_URL, {
        method: 'POST',
        mode: 'no-cors',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          formName        : 'ComplaintRegistration',
          contact_person  : data.ContactPerson,
          email           : data.Email,
          mobile          : '+91' + data.Mobile,
          company         : data.Company,
          address         : data.Address,
          city            : data.City,
          state           : data.State,
          pincode         : data.Pincode,
          purchase_channel: data.PurchaseChannel,
          invoice_number  : data.InvoiceNumber,
          problem         : data.Problem,
          utm_source      : utm.utm_source,
          utm_medium      : utm.utm_medium,
          utm_campaign    : utm.utm_campaign,
          gclid           : utm.gclid
        })
      })
        .then(function () {
          setLoading(false);
          showSuccess();
        })
        .catch(function (err) {
          console.error('Submit Error:', err);
          setLoading(false);
          apiError.textContent   = '❌ Something went wrong. Please try again.';
          apiError.style.display = 'block';
        });
    });
  }

  // Init on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initComplaintRegistration);
  } else {
    initComplaintRegistration();
  }

  // Re-init for Shopify Theme Editor live reloads
  document.addEventListener('shopify:section:load', initComplaintRegistration);

})();